import { Injectable } from '@angular/core';
import { Observable ,  of } from 'rxjs';
import { ApiUrlHelper } from '../api-url-helper';
import { HttpClientHelper } from '../http-helper';
import { MessageTransFormer } from '../../_transformers/message.transformer';
import { map } from 'rxjs/operators';

@Injectable()
export class MessageService {
    constructor(
        private _apiUrlHelper: ApiUrlHelper,
        private _httpClientHelper: HttpClientHelper,
        private _messageTransFormer: MessageTransFormer,
    ) {

    }
    public getMessages(user, page = 1, type = 0, size = 0): Observable<any[]> {
        if (!user) {
            return of([]);
        }
        const apiURL = this._apiUrlHelper.urlBuilder('user-messages',{
            type:type,
            page:page,
            size:size
        });
        return this._httpClientHelper.get(apiURL)
        .pipe(map((res) => {
                return res.map(m => {
                    return {
                        count: m.count,
                        list: m.result.map(l => {
                            return this._messageTransFormer.transform(l);
                        })
                    };
                });
            }));
    }

    getFollowedNotifications(user, page = 1, size = 10): Observable<any[]> {
        if (!user) {
            return of([]);
        }
        const apiURL = this._apiUrlHelper.urlBuilder('get-user-attend-msg',{
            page: page,
            size: size
        });
        return this._httpClientHelper.get(apiURL)
        .pipe(map((res) => {
            return res.map(m => {
                return {
                    count: m.recordNum,
                    list: m.list
                };
            });
        }));
    }

    getLikedNotifications(user, page = 1, size = 10): Observable<any[]> {
        if (!user) {
            return of([]);
        }
        const apiURL = this._apiUrlHelper.urlBuilder('get-user-zan-msg',{
            page: page,
            size: size
        });
        return this._httpClientHelper.get(apiURL)
        .pipe(map((res) => {
            return res.map(m => {
                return {
                    count: m.recordNum,
                    list: m.list
                };
            });
        }));
    }
}
